

































































































































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import ProfileConnector from '@/connector/Profile.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import TransactionService from '@/services/TransactionService';
import PromotionService from '@/services/PromotionService';
import moment from 'moment';
import AuthConnector from '@/connector/Auth.vue';

const transactionService = new TransactionService();
const promotionService = new PromotionService();

@Component({
  components: {
    AuthConnector,
    ProfileConnector,
    BaseDataTable,
  },
})
export default class LoginDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public creditTurn: any = {};

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  public amount: number = 0;

  public loading: boolean = false;

  public turnoverTarget: number = 0;

  public async requestWithdraw(refreshCallback: Function) {
    try {
      this.loading = true;
      await transactionService.requestWithdraw({ amount: this.amount });
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: 'ดำเนินการเรียบร้อยแล้ว', error: false });
      this.$store.dispatch('Profile/getProfile');
      await refreshCallback();
      (this.$refs.WITHDRAW_TABLE as Vue & { refreshData: () => void }).refreshData();
      this.amount = 0;
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
      this.loading = false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  public formatDate(time: number) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }

  // eslint-disable-next-line class-methods-use-this
  get withdrawListUrl() {
    return `${process.env.VUE_APP_API_ENDPOINT}/transactions/withdraw`;
  }

  // eslint-disable-next-line class-methods-use-this
  async created() {
    const { data } = await promotionService.checkTurnover();
    this.creditTurn = { ...data };
  }
}
